import React, { useEffect, useState } from 'react';

import Product from './Product';
import { ProductState } from './GroupedProductView';
import useProductStatic from 'hooks/ProductPageV2/useProductStatic';
import { StockStatusType } from 'types/ProductPageV2/ProductsStocks';
import { ProductType } from 'types/ProductPageV2/Products';

type Props = {
  path: string;
  setIsReady: (isReady: boolean) => void;
  setProduct: (product: ProductState) => void;
};

export type SelectedProduct = ProductType & {
  stockState?: StockStatusType;
  qty: number;
};

export default function ProductWrapper({
  path,
  setIsReady,
  setProduct,
}: Props): JSX.Element {
  const [color, setColor] = useState<string>();
  const { data } = useProductStatic(path, color);

  useEffect(() => {
    if (data) {
      setIsReady(true);
    }
  }, [data]);

  if (!data) {
    return <></>;
  }

  return (
    <Product
      formattedProduct={data}
      color={color}
      setColor={setColor}
      setSelectedProduct={product => {
        setProduct({
          ...product,
          productType: data.productType,
          colors: data.colors,
        });
      }}
    />
  );
}
